import { ProtectedSidebarLink } from '@britishcouncil/react-admin';

import { ROUTING_PATHS } from 'const';
import { BulkActionsSidebar } from './BulkActionsSidebar';
import { ExaminerSidebar } from './ExaminerSidebar';
import { ReportsSidebar } from './ReportsSidebar';

export const Sidebar = () => {
  const { dashboard, examiners, users } = ROUTING_PATHS;
  return (
    <>
      <ProtectedSidebarLink {...dashboard} name="Dashboard" icon="dashboard" />
      <ProtectedSidebarLink {...examiners.list} name="Examiners" icon="users" />
      <ExaminerSidebar />
      <ProtectedSidebarLink {...users} name="Users" icon="users" />
      <ReportsSidebar />
      <BulkActionsSidebar />
    </>
  );
};
